export const spin = { minHeight: '100vh' };
export default spin;
